module.exports = __webpack_public_path__ + "img/logo.9ee575a9.png";